// /admin/v1/lora/* — LoRA 训练管线 (content-scale-lora).

import { get, post } from './client';

export type LoRAJobStatus = 'queued' | 'training' | 'succeeded' | 'failed';
export type LoRAModelStatus = 'training' | 'ready' | 'failed' | 'archived';

export interface LoRATrainingJob {
  id: string;
  app_id: number;
  lora_name: string;
  status: LoRAJobStatus;
  provider: string;
  error?: string;
  lora_model_id?: number;
}

export interface LoRAModel {
  id: number;
  app_id: number;
  name: string;
  status: LoRAModelStatus;
  provider: string;
  trigger_word?: string;
  base_model?: string;
}

export interface SubmitTrainingInput {
  app_id: number;
  lora_name: string;
  dataset_ref?: string;
  base_model?: string;
}

export function submitTraining(input: SubmitTrainingInput): Promise<LoRATrainingJob> {
  return post<LoRATrainingJob>('/admin/v1/lora/train', input);
}

export function getJob(id: string): Promise<LoRATrainingJob> {
  return get<LoRATrainingJob>(`/admin/v1/lora/jobs/${id}`);
}

export function listModels(appId: number): Promise<{ data: LoRAModel[] }> {
  return get<{ data: LoRAModel[] }>(`/admin/v1/lora/models?app_id=${appId}`);
}

// series-lora-binding / 审核 / sample-autogen (on content packages)
export function bindLoRA(packageId: number, loraModelId: number): Promise<unknown> {
  return post(`/admin/v1/content/packages/${packageId}/lora`, { lora_model_id: loraModelId });
}

export function reviewPackage(packageId: number, to: string): Promise<unknown> {
  return post(`/admin/v1/content/packages/${packageId}/review`, { to });
}

export function triggerSampleAutogen(packageId: number, count = 4): Promise<{ run_id: string }> {
  return post<{ run_id: string }>(`/admin/v1/lora/packages/${packageId}/sample-autogen`, { count });
}
